import { type Component, type ComponentProps, mount } from 'svelte'
import AppLayout from '#components/app_layout.svelte'

export let appLayout: ReturnType<typeof mount> & {
  showChildComponent: typeof showChildComponent
  removeCurrentComponent: typeof removeCurrentComponent
}

const appLayoutProps = $state({})

export function initAppLayout () {
  const target = document.getElementById('app')
  // Remove spinner
  target.innerHTML = ''
  appLayout = Object.assign(mount(AppLayout, { target, props: appLayoutProps }), {
    showChildComponent,
    removeCurrentComponent,
  })
  return appLayout
}

export interface RegionComponent {
  component: Component
  props?: ComponentProps<Component>
}

export type RegionName = 'main' | 'modal' | 'svelteModal'

function showChildComponent (regionName: RegionName, component: Component, options: { props?: ComponentProps<Component> } = {}) {
  const props = 'props' in options ? options.props : {}
  if (component != null) {
    appLayoutProps[regionName] = { component, props }
  } else {
    appLayoutProps[regionName] = null
  }
}

function removeCurrentComponent (regionName: RegionName) {
  appLayoutProps[regionName] = null
}
